import React from 'react'
import { Box, FormControlLabel, Radio } from '@mui/material'
import { FeedPatientResponseItemSectionEntryFragment } from 'src/feed/feedQueries.generated'
import makeStyles from '@mui/styles/makeStyles'
import classNames from 'classnames'
import { Question } from 'src/feed/FeedComponents'
import { exhaustiveCheck } from 'src/lib/exhaustiveCheck'
import ChoiceLabel from './ChoiceLabel'

type Props = {
  entry: Omit<FeedPatientResponseItemSectionEntryFragment, 'entryContext'> & {
    entryContext: NonNullable<FeedPatientResponseItemSectionEntryFragment['entryContext']>
  }
}

export default function SectionEntryWithContext({ entry }: Props) {
  const styles = useStyles()
  const { entryContext } = entry
  switch (entryContext.__typename) {
    case 'PatientResponseSectionEntryContextSingleChoice':
      return (
        <Box>
          {entry.question && <Question content={entry.question} />}
          {entryContext.options.map((option) => {
            const isChecked = option.value === entry.rawValue
            return (
              <Box mt={0.5} key={option.value}>
                <FormControlLabel
                  disabled
                  classes={{ root: styles.formControlRoot, label: styles.labelRoot }}
                  checked={isChecked}
                  label={<ChoiceLabel content={option.label} highlighted={isChecked} />}
                  control={<Radio className={classNames(styles.controlRoot, { [styles.checked]: isChecked })} />}
                />
              </Box>
            )
          })}
        </Box>
      )
    case undefined:
      return null
    default: {
      return exhaustiveCheck(entryContext.__typename, null)
    }
  }
}

const useStyles = makeStyles((theme) => ({
  formControlRoot: {
    margin: 0,
  },
  labelRoot: {
    paddingLeft: theme.spacing(1),
    lineHeight: 1.3,
    fontSize: '0.75rem',
  },
  controlRoot: {
    padding: 0,
  },
  checked: {
    // to override disabled coloring
    color: `${theme.palette.text.primary} !important`,
  },
}))
